
export default {
  data() {
    return {
      width: 439.6,
    }
  },
  props: {
    percent: {
      default: 0,
      type: Number,
    },
    color: {
      default: '#60e6a8',
      type: String,
    },
    strokeWidth: {
      default: 12,
      type: Number,
    },
  },
  computed: {
    dashoffsetByPercent() {

      return this.width - (this.percent * this.width) / 100
    },
  },
}
